module.exports = __webpack_public_path__ + "img/lk-mode-credit-card-green.85c1eef0.svg";